import { BaseEventBuilder } from '@droidmap/shared-service-contract'

import { AssetSetOperation } from '../models/asset-set-operation.js'
import {
  Asset,
  AssetSet,
  AssetWithPresignedUrl,
  DownloadJob,
} from '../models/asset.js'

const serviceSource = 'droidmap.backend.asset-service'

export const AssetCreated = new BaseEventBuilder<
  Asset | AssetWithPresignedUrl,
  'Asset Created'
>(serviceSource, 'Asset Created')

export const AssetDeleted = new BaseEventBuilder<Asset, 'Asset Deleted'>(
  serviceSource,
  'Asset Deleted',
)

export const AssetUploadComplete = new BaseEventBuilder<
  AssetWithPresignedUrl,
  'Asset Uploaded'
>(serviceSource, 'Asset Uploaded')

export const AssetUpdated = new BaseEventBuilder<Asset, 'Asset Updated'>(
  serviceSource,
  'Asset Updated',
)

export const AssetSetCreated = new BaseEventBuilder<
  AssetSet,
  'Asset Set Created'
>(serviceSource, 'Asset Set Created')

export const AssetSetUpdated = new BaseEventBuilder<
  AssetSet,
  'Asset Set Updated'
>(serviceSource, 'Asset Set Updated')

export const AssetSetDeleted = new BaseEventBuilder<
  AssetSet,
  'Asset Set Deleted'
>(serviceSource, 'Asset Set Deleted')

/* ------------------------------ DownloadJob Events ----------------------- */

export const DownloadJobCreated = new BaseEventBuilder<
  DownloadJob,
  'Download Job Created'
>(serviceSource, 'Download Job Created')

export const DownloadJobUpdated = new BaseEventBuilder<
  DownloadJob,
  'Download Job Updated'
>(serviceSource, 'Download Job Updated')

export const DownloadJobCompleted = new BaseEventBuilder<
  DownloadJob,
  'Download Job Completed'
>(serviceSource, 'Download Job Completed')

export const DownloadJobFailed = new BaseEventBuilder<
  DownloadJob,
  'Download Job Failed'
>(serviceSource, 'Download Job Failed')

/* -------------------------- AssetSetOperation Events ---------------------- */

/**
 * Emitted when an asset-set operation is accepted; the asset service consumes
 * it from its own event queue to do the work.
 */
export const AssetSetOperationCreated = new BaseEventBuilder<
  AssetSetOperation,
  'Asset Set Operation Created'
>(serviceSource, 'Asset Set Operation Created')
